import { useState } from 'react'
import { RadioGroup, RadioButton, Stack, Table } from '@postenbring/hedwig-react'

// This part is an updated version of an xp6 part
// To avoid having to change the data from our sites while migrating, some shortcuts have been made "just to get it to work"
// I strongly recommend to rewrite this part!


export const TableWFilter = ({ table, tableColumn, filters }) => {
    const [filter, setFilter] = useState('ALL')

    const rows = getTableRows(table)

    function filterTable(value) {
        setFilter(value.toUpperCase())
    }

    function getTableRows(tableRaw) {
        const parser = new DOMParser()
        const res = parser.parseFromString(tableRaw, 'text/html')
        const rows = res.getElementsByTagName('tr')
        return rows
    }

    const Filters = () => (
        <Stack gap='20-24' direction={{ initial: "column", small: "row" }} asChild>
            <RadioGroup name='filter' onChange={(e) => filterTable(e.target.value)}>
                {filters.map(({ value, label }) => (
                    <RadioButton
                        checked={value === filter}
                        value={value}
                        key={value}
                    >
                        {label}
                    </RadioButton>
                ))}
            </RadioGroup>
        </Stack>
    )

    function HeadRow({ headerRow }) {
        const cells = [].slice.call(headerRow.cells).map((cell, idx) => {
            let cellcontent = { __html: cell.innerHTML }
            return <th key={idx} dangerouslySetInnerHTML={cellcontent}></th>
        })

        return <thead>{cells}</thead>
    }

    function ContentRows({ contentRows }) {
        let cells = ''

        const rows = [].slice.call(contentRows).map((row, index) => {
            const test = (cells = [].slice.call(row.cells)[tableColumn]
                .innerHTML)

            if (
                index > 0 &&
                (filter === 'ALL' || test.toUpperCase().includes(filter))
            ) {
                cells = contentCells(row)
                return <tr key={index}>{cells}</tr>
            } else {
                return ''
            }
        })

        return <tbody>{rows}</tbody>
    }

    function contentCells(tableRow) {
        const cells = [].slice.call(tableRow.cells).map((cell, idx) => {
            let cellcontent = { __html: cell.innerHTML }
            return <td key={idx} dangerouslySetInnerHTML={cellcontent}></td>
        })
        return cells
    }

    return (
        <>
            <Filters />
            <Table className='hds-mb-24'>
                <HeadRow headerRow={rows[0]} />
                <ContentRows contentRows={rows} />
            </Table>
        </>
    )
}
